import styled from 'styled-components'
import { AiResumeReview } from 'builder/components/AiFeatures/AiResumeReview/AiResumeReview'
import { hideScrollMixin } from 'builder/components/ScrollContainer'

export const StyledAiResumeReview = styled(AiResumeReview)`
  ${hideScrollMixin}

  flex: auto;
  padding: 4px;
  margin-top: 0;
`

export const MobileContainer = styled.div`
  padding-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: auto;
`
